<template>
  <div ref="inputbox">
    <b-form-input
      class="sr__input"
      :class="{'sr__input--invalid': !this.valid}"
      v-model="value"
      :disabled="disable"
    ></b-form-input>

    <b-form-invalid-feedback :state="valid">
      {{invalidMsg}}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
export default {
  name: 'InputItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      value: '',
      valid: true,
      invalidMsg: '',
      toValidate: true
    }
  },
  watch: {
    value () {
      this.field.value = this.value
      this.checkValueIsValid()
    }
  },
  methods: {
    checkValueIsValid (uiNotify = true) {
      if (!this.toValidate) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (this._isDestroyed) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (!this.value) {
        if (!uiNotify) {
          return false
        }

        this.valid = false
        this.invalidMsg = '欄位必填'
      } else {
        this.valid = true
        this.invalidMsg = ''
      }

      return this.valid
    }
  },
  created () {
    this.toValidate = this.field.validates?.presence
    this.value = this.field.value
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    if (this.toValidate) {
      this.$store.dispatch('pushValidateInfo', {
        id: this._uid,
        top: () => { return top },
        checkValueIsValid: this.checkValueIsValid
      })
    }
  }
}
</script>
